import React, { Component } from "react";
import { connect } from "react-redux";
import { setCurrentClient } from "thunks";
import { uniqBy } from "lodash";
import { updateUrlFilter, getAllowedClient } from "../services/utils";
import { setStatisticsEventsFilter } from "../actions/actions/statistics";
import NotFoundFrame from "../pages/NotFoundFrame";

@connect(store => ({
  auth: store.auth
}))
export default class CommunityRedirect extends Component {
  componentDidMount() {
    const { routeParams, auth, dispatch } = this.props;
    if (auth.user && routeParams.communityId != undefined) {
      let paymentClients = uniqBy(auth.user.paymentClients, "id");
      const community = getAllowedClient(
        paymentClients.find(client => client.id == routeParams.communityId),
        paymentClients
      );

      dispatch(setStatisticsEventsFilter([]));
      window.history.replaceState(null, null, document.referrer);

      if (!community) {
        return;
      }

      dispatch(setCurrentClient(community)).then(() => {
        updateUrlFilter("appRefs", "in", []);
        updateUrlFilter("clientId", "in", [String(community.id)]);
      });
    }
  }

  render() {
    // return <NotFoundFrame />;
    return null;
  }
}



// WEBPACK FOOTER //
// ./app/components/CommunityRedirect.js